<template>
  <div>
    <b-row :class="$route.name == 'UpdatePassword' ? 'mt-5' : ''">
      <b-col
        :cols="$route.name == 'UpdatePassword' ? '6' : '12'"
        :offset="$route.name == 'UpdatePassword' ? '3' : '0'"
      >
        <b-form-group>
          <b-row>
            <b-col cols="4">
              <label>
                Current Password
                <span class="required-span">*</span>
              </label>
            </b-col>
            <b-col cols="8">
              <b-form-input
                size="sm"
                v-model="$v.passwordForms.currentPassword.$model"
                :state="$v.passwordForms.currentPassword.$dirty ? !$v.passwordForms.currentPassword.$error : null"
                type="password"
                placeholder="Enter Current Password"
              ></b-form-input>
              <b-form-invalid-feedback>This field is required</b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group>
          <b-row>
            <b-col cols="4">
              <label>
                New Password
                <span class="required-span">*</span>
              </label>
            </b-col>
            <b-col cols="8">
              <b-form-input
                size="sm"
                v-model="$v.passwordForms.newPassword.$model"
                :state="$v.passwordForms.newPassword.$dirty ? !$v.passwordForms.newPassword.$error : null"
                type="password"
                placeholder="Enter New Password"
              ></b-form-input>
              <b-form-invalid-feedback>This is a required field and must be at least 6 characters.</b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group>
          <b-row>
            <b-col cols="4">
              <label>
                Confirm Password
                <span class="required-span">*</span>
              </label>
            </b-col>
            <b-col cols="8">
              <b-form-input
                size="sm"
                v-model="$v.passwordForms.confirmNewPassword.$model"
                :state="$v.passwordForms.confirmNewPassword.$dirty ? !$v.passwordForms.confirmNewPassword.$error : null"
                type="password"
                placeholder="Enter Confirm Password"
              ></b-form-input>
              <b-form-invalid-feedback
                class="error"
                v-if="!$v.passwordForms.confirmNewPassword.sameAsPassword"
              >Passwords must be identical</b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-form-group>
        <b-row>
          <b-col cols="12">
            <b-button
              class="float-right"
              type="button"
              @click="onUpdatePassword"
              variant="primary"
            >Update</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { HTTP } from "../../utils/HTTP";
import { validationMixin } from "vuelidate";
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import { Helper } from "../../helpers";
export default {
  name: "UpdatePassword",
  mixins: [validationMixin],
  data() {
    return {
      passwordForms: {
        currentPassword: null,
        newPassword: null,
        confirmNewPassword: null,
      },
      userDetail: null,
    };
  },
  validations: {
    passwordForms: {
      currentPassword: {
        required,
      },
      newPassword: {
        required,
        minLength: minLength(6),
      },
      confirmNewPassword: {
        sameAsPassword: sameAs("newPassword"),
      },
    },
  },
  mounted() {
    // console.log(this.$route.name);
    this.setUserDetail();
  },
  methods: {
    setUserDetail() {
      let datail = JSON.parse(localStorage.getItem("userDetail"));
      this.userDetail = datail;
    },
    makeUpdatePasswordToster(tosterVarient, tosterMsg) {
      Helper.makeToast(this.$bvToast, tosterVarient, tosterMsg);
      if (tosterVarient == "success") {
        if (this.$route.name == "UpdatePassword") {
          if (this.userDetail.user_type == 3) {
                this.$router.push("/dashboard");
          } else if (this.userDetail.user_type == 2) {
                this.$router.push("/dashboard");
          } else {
                this.$router.push("/manage-employee");
          }
        }
      }
    },
    onUpdatePassword() {
      this.$v.passwordForms.$touch();
      if (this.$v.passwordForms.$anyError) {
        return;
      } else {
        this.updatePasswordApiCall();
      }
    },
    async updatePasswordApiCall() {
      let formData = {
        userId: this.userDetail.id,
        currentPassword: this.passwordForms.currentPassword,
        newPassword: this.passwordForms.newPassword,
        user_id: localStorage.getItem("userId"),
      };
      try {
        let result = await HTTP(
          "post",
          "api/v1/user/update/password",
          formData
        );
        if (result.data.status == 0) {
          this.makeUpdatePasswordToster("warning", result.data.message);
        } else if (result.data.status == 1) {
          this.makeUpdatePasswordToster("warning", result.data.message);
        } else if (result.data.status == 2) {
          this.makeUpdatePasswordToster("danger", result.data.message);
        } else if (result.data.status == 3) {
          this.makeUpdatePasswordToster("warning", result.data.message);
        } else if (result.data.status == 4) {
          this.makeUpdatePasswordToster("success", result.data.message);
        }
        this.passwordForms = {
          currentPassword: null,
          newPassword: null,
          confirmNewPassword: null,
        };
        this.$v.$reset();
      } catch (err) {
        return [err];
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
</style>